<template>
  <Layout>
    <div class="w-full bg-gray-100 py-3">
      <div class="max-w-6xl mx-auto px-4 lg:px-8">
        <ol class="flex items-center text-sm text-gray-500">
          <li>
            <router-link to="/" class="hover:text-primary">Home</router-link>
          </li>
          <li class="before:content-['/'] before:mx-2 hover:text-primary">
            <router-link to="/blog" class="hover:text-primary">Blog</router-link>
          </li>
          <li class="before:content-['/'] before:mx-2 text-gray-800 truncate max-w-xs">{{ article.title || 'News Details' }}</li>
        </ol>
      </div>
    </div>

    <div class="max-w-6xl mx-auto px-4 lg:px-8 py-6">

      <div v-if="loading" class="py-20 text-center text-gray-400">Loading...</div>

      <div v-else-if="notFound" class="py-20 text-center">
        <p class="text-gray-500 mb-4">Article not found</p>
        <router-link to="/blog" class="text-primary hover:text-primary-dark">&larr; Back to Blog</router-link>
      </div>

      <article v-else>
        <h1 class="text-2xl lg:text-3xl font-bold text-gray-800 leading-snug mb-4">{{ article.title }}</h1>

        <div class="flex flex-wrap gap-x-6 gap-y-1 text-sm text-gray-500 pb-4 mb-6 border-b border-gray-200">
          <span>Views: {{ article.views }}</span>
          <span>Author: {{ article.author }}</span>
          <span>Publish Time: {{ article.publishDate }}</span>
          <span>Origin: {{ article.origin }}</span>
        </div>

        <div v-if="hasContent" class="article-content" v-html="article.content"></div>
        <p v-else class="text-gray-400">No content yet.</p>
      </article>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/common/CommonLayout";

export default {
  name: "NewsDetailsView",
  components: { Layout },
  data() {
    return { article: {}, loading: true, notFound: false };
  },
  computed: {
    // 编辑器保存空内容时落到库里是 '<p><br></p>'，只靠真值判断会渲染出空白正文
    hasContent() {
      const html = this.article.content || '';
      if (/<img\b/i.test(html)) return true;
      return html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim().length > 0;
    }
  },
  watch: {
    // 文章之间跳转时路由复用同一组件，只靠 mounted 会停留在上一篇的内容
    '$route.params.newsId': function (newId) {
      if (newId) this.fetchArticle(newId);
    }
  },
  mounted() {
    this.fetchArticle(this.$route.params.newsId);
  },
  methods: {
    async fetchArticle(newsId) {
      this.loading = true;
      this.notFound = false;
      try {
        const resp = await this.getRequest(`/api/articles/${newsId}`);
        const body = resp && resp.data;
        if (body && body.code === 200 && body.data) {
          this.article = body.data;
        } else {
          this.article = {};
          this.notFound = true;
        }
      } catch (e) {
        console.error('加载文章详情失败', e);
        this.article = {};
        this.notFound = true;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.article-content { color: #374151; line-height: 1.75; word-break: break-word; }
/* v-html 注入的内容不受 scoped 样式约束，必须用 :deep() */
.article-content :deep(p) { margin: 0 0 1rem; }
.article-content :deep(img) { max-width: 100%; height: auto; margin: 1rem 0; }
.article-content :deep(h1),
.article-content :deep(h2),
.article-content :deep(h3),
.article-content :deep(h4) { font-weight: 700; color: #1f2937; line-height: 1.4; margin: 1.5rem 0 0.75rem; }
.article-content :deep(ul) { list-style: disc; padding-left: 1.5rem; margin: 0 0 1rem; }
.article-content :deep(ol) { list-style: decimal; padding-left: 1.5rem; margin: 0 0 1rem; }
.article-content :deep(blockquote) { border-left: 4px solid #e5e7eb; color: #6b7280; padding-left: 1rem; margin: 0 0 1rem; }
.article-content :deep(table) { width: 100%; border-collapse: collapse; margin: 0 0 1rem; }
.article-content :deep(td),
.article-content :deep(th) { border: 1px solid #e5e7eb; padding: 0.5rem; }
</style>
